<template>
    <div class="min-h-screen bg-primary-color flex flex-col py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <img class="mx-auto h-12 w-auto" src="/img/logo.png" alt="Workflow">
        </div>
        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-6xl rounded-xl bg-white px-8 py-12">
            <public-board-notes-list :items="items"></public-board-notes-list>
        </div>
    </div>
</template>


<script>
import PublicBoardNotesList from "@/Components/BoardNotes/PublicBoardNotesList";

export default {
    components: { PublicBoardNotesList },
    props: {
        items: Array,
        required: true,
    }
}
</script>
